"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSortIconWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * @since 8.41.0
 */
var TableSortIconWrapper = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "TableSortIconWrapper",
  componentId: "c11n-8-107-0__sc-7tgvt6-0"
})([""]);
exports.TableSortIconWrapper = TableSortIconWrapper;
TableSortIconWrapper.displayName = 'TableSortIconWrapper';

/** @component */